<div class="container p-4">
  <div class="row d-flex justify-content-center">
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    <div class="col-12 text-center modal-title mb-2">{{'CONFIRM_WITHDRAW' | translate}}</div>
    <div class="col-12 text-center modal-subtitle mb-4"
      [innerHTML]="'CONFIRM_WITHDRAW_SUBTITLE' | translate: { requestName: info.title } "></div>
  </div>
  <div class="row">
    <div class="col-6 mt-4 d-flex justify-content-center">
      <button mat-flat-button class="btn-action white cancel-btn" (click)="closeModal()">{{'CANCEL' |
        translate}}</button>
    </div>
    <div class="col-6 mt-4 d-flex justify-content-center">
      <button mat-flat-button class="btn-action error withdraw-btn" (click)="confirmWithdraw()">{{'WITHDRAW' |
        translate}}</button>
    </div>
  </div>
</div>